const ROLE_POLICY_V2_DISABLED_MESSAGE =
  "Role policy management is not enabled in this environment.";

export function isRolePolicyV2Enabled() {
  return (
    process.env.NEXT_PUBLIC_ROLE_POLICY_V2_ENABLED?.trim().toLowerCase() ===
    "true"
  );
}

export function assertRolePolicyV2Enabled() {
  if (!isRolePolicyV2Enabled()) {
    throw new Error(ROLE_POLICY_V2_DISABLED_MESSAGE);
  }
}

export { ROLE_POLICY_V2_DISABLED_MESSAGE };
